<template>
  <li class="dropdown-item" style="padding: 0">
    <a
      style="padding: 1rem"
      target="_blank"
      v-if="href.slice(href.length - 4) == '.pdf'"
      @click="forceClickToggleBar()"
      class="d-inline-block w-100"
      :class="isTheUrl ? 'active-custom-ff' : ''"
      :href="href"
      >{{ title }}</a
    >
    <Link style="padding: 1rem" v-else @click="width < 1147 ? forceClickToggleBar(): dekstopForceClickToggleBar(indexParent+2)" class="d-inline-block w-100" :class="{'active-custom-ff' : isTheUrl}" :href="href"
      >{{ title }}</Link
    >
  </li>
</template>

<script>
export default {
  props: {
    title: String,
    isTheUrl: Boolean,
    href: String,
    width: Number,
    indexParent: Number,
  },
};
</script>

<style>
</style>
